import CloseIcon from '@mui/icons-material/Close'
import {Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography} from '@mui/material'
import {ReactNode} from 'react'

type SlaCommentsModalViewProps = {
  open: boolean
  onClose: () => void
  title: string
  children: ReactNode
  disableFocusManagement?: boolean
}

export const SlaCommentsModalView = ({
  open,
  onClose,
  title,
  children,
  disableFocusManagement = false
}: SlaCommentsModalViewProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{sx: {overflow: 'visible'}}}
      disableEnforceFocus={disableFocusManagement}
      disableRestoreFocus={disableFocusManagement}
      disableAutoFocus={disableFocusManagement}
    >
      <DialogTitle sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
        <Typography variant="h4">{title}</Typography>
        <IconButton onClick={onClose} aria-label="close-comments-modal">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{overflow: 'visible', overflowY: 'visible'}}>
        <Stack spacing={3} sx={{mt: 1}}>
          {children}
        </Stack>
      </DialogContent>
    </Dialog>
  )
}
